import React from "react";
import tokenProvider from "core/tokenProvider";
import usePermissions from "helpers/usePermissions";

export const DOWNLOAD_URL =
  "https://fluid-it.fr/ressources/fluidit-driver-download.html";

const STORAGE_KEY = "announcement_driver_app_dismissed";

const readDismissed = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

const useDriverAppAnnouncement = () => {
  const [dismissed, setDismissed] = React.useState(readDismissed);
  const { isContractor } = usePermissions();
  const hasToken = tokenProvider.getToken();

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {
      // localStorage unavailable
    }
  };

  /* re-read storage on each render so banner and navbar link stay in sync */
  const isVisible =
    Boolean(hasToken) && !isContractor && !dismissed && !readDismissed();

  return { isVisible, dismiss };
};

export default useDriverAppAnnouncement;
